import React from 'react';
import styled from 'styled-components';

import About from './components/about';
import ProjectBox from './components/project';
import ContactBox from './components/contact';

const Main = ({ lang, changeLang }) => {
  return (
    <Container>
      <About
        lang={lang}
        changeLang={changeLang}
      />
      <ProjectBox lang={lang} />
      <ContactBox
        lang={lang}
        changeLang={changeLang}
      />
    </Container>
  );
};

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

export default Main;
